import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import {
  GraphQLEndpoints,
  graphQlBrowseApiRef,
} from '@backstage-community/plugin-graphiql';

/**
 * Replaces the GraphiQL endpoint list with the Bobbee APIs, reached through the backend
 * relay (bobbee-graphql plugin) with Backstage's authenticated fetch. In GraphiQL's
 * Headers tab, set X-Bobbee-Authorization (your Bobbee token) and X-companyId/X-userId.
 */
export const graphiqlModule = createFrontendModule({
  pluginId: 'graphiql',
  extensions: [
    ApiBlueprint.make({
      params: defineParams =>
        defineParams({
          api: graphQlBrowseApiRef,
          deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
          factory: ({ fetchApi, discoveryApi }) =>
            GraphQLEndpoints.from([
              GraphQLEndpoints.create({
                id: 'bobbee-dev',
                title: 'Bobbee dev',
                url: discoveryApi
                  .getBaseUrl('bobbee-graphql')
                  .then(base => `${base}/dev`),
                fetchApi,
              }),
            ]),
        }),
    }),
  ],
});
